import Icon from "@ant-design/icons";
import { ReactComponent as ArrowSvg } from "../assets/svg/arrow.svg";
import { ReactComponent as EraLogoSvg } from "../assets/svg/era-logo-short.svg";
import { ReactComponent as UserSvg } from "../assets/svg/user.svg";
import { ReactComponent as LikeOutlinedSvg } from "../assets/svg/likeoutlined.svg";
import { ReactComponent as DislikeOutlinedSvg } from "../assets/svg/dislikeoutlined.svg";
import { ReactComponent as LikeFilledSvg } from "../assets/svg/likefilled.svg";
import { ReactComponent as DislikeFilledSvg } from "../assets/svg/dislikefilled.svg";
import { ReactComponent as CopySvg } from "../assets/svg/copy.svg";
import { ReactComponent as StopSvg } from "../assets/svg/stop.svg";
import { ReactComponent as StripSVG } from "../assets/svg/three-line-drawer.svg";
import { ReactComponent as CloseSVG } from "../assets/svg/close.svg";

export const ArrowIcon = (props) => <Icon component={ArrowSvg} {...props} />;
export const EraLogoIcon = (props) => (
  <Icon component={EraLogoSvg} {...props} />
);
export const UserIcon = (props) => <Icon component={UserSvg} {...props} />;
export const LikeOutlinedIcon = (props) => (
  <Icon component={LikeOutlinedSvg} {...props} />
);
export const DislikeOutlinedIcon = (props) => (
  <Icon component={DislikeOutlinedSvg} {...props} />
);
export const LikeFilledIcon = (props) => (
  <Icon component={LikeFilledSvg} {...props} />
);
export const DislikeFilledIcon = (props) => (
  <Icon component={DislikeFilledSvg} {...props} />
);

export const CopyIcon = (props) => (
  <Icon component={() => <CopySvg fill="white" />} {...props} />
);

export const StopIcon = (props) => (
  <Icon component={() => <StopSvg />} {...props} />
);

export const StripIcon = (props) => (
  <Icon component={() => <StripSVG />} {...props} />
);

export const CloseIcon = (props) => (
  <Icon component={() => <CloseSVG />} {...props} />
);
